import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { FileProvider } from './context/FileContext';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import ThankYouPage from './pages/ThankYouPage';

ReactDOM.render(
  <React.StrictMode>
    <FileProvider>
      <Router>
        <Switch>
          <Route exact path="/" component={App} />
          <Route path="/thank-you" component={ThankYouPage} />
        </Switch>
      </Router>
    </FileProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
